import PropTypes from "prop-types";
import React, { Component } from "react";
import logo from "static/images/logo.png";
import {MSpinner} from "components/Shared";

class LoginSso extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      isHandlingToken: false
    };

    this.ssoUserLogin = this.ssoUserLogin.bind(this);
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    if (!this.state.isHandlingToken){
      this.ssoUserLogin(params.SSO);
    }
  }

  ssoUserLogin(ssoToken){
    this.setState({
      isHandlingToken: true,
      isFetching: true
    });
    this.props.userLogin({
      sso: ssoToken
    });
  }

  render() {
    return (
      <div className="md-grid md-cell login-wrapper">
        <div className="login-form">
          <img src={logo} alt="logo.png" className="mueller-logo" />
          <h3 className="mueller-title" data-test="title" title="Authenticating login">Validating Credentials</h3>
          <MSpinner/>
        </div>
      </div>
    );
  }

}

LoginSso.propTypes = {
  userLogin: PropTypes.func.isRequired,
  match: PropTypes.object,
  SSO: PropTypes.string
};

export default LoginSso;
